import { initializeApp, getApps } from 'firebase/app';
import { firebaseConfig } from './firebase-config';

// Initialize Firebase app only if it hasn't been initialized
export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];